/* globals $ history */

/*
 * manage expandable lists history state in URL
 * TODO : merge this function in the _manage expandable lists state_ function below this one
 */
(function () {
  if ($('.js-expandable-button').length > 0) {
    var windowLocation = window.location.toString()
    var hashPosition = windowLocation.indexOf('#')

    if (hashPosition !== -1) {
      $(window).on("load", function () {
        var programType = (windowLocation.substring(hashPosition)).split('?')[0]
        var parentTabPanel = $(programType).closest('[role="tabpanel"]')
        var parentTabPanelId = ''
        var parentListItems = $(programType).parents('.expandable-list__item')

        if ($(programType).closest('.js-expandable-button').length > 0) {
          // Open parent tabpanel if necessary
          if (parentTabPanel.length > 0) {
            parentTabPanelId = parentTabPanel.attr('id')
            $('button[aria-controls="' + parentTabPanelId + '"]').trigger('click')
          }

          // Open parent expandable-list if necessary
          if (parentListItems.length > 1) {
            $(parentListItems[1]).children('.js-expandable-button').trigger('click')
            setTimeout(function () {
              $(programType).closest('.js-expandable-button').trigger('click')
            }, 500)
          } else {
            // Open current expandable-list
            $(programType).closest('.js-expandable-button').trigger('click')
          }
        }
      })
    }

    $('.js-expandable-button').click(function () {
      var programTitle = $(this).find('.expandable-list__item-title').attr('id')

      var newLocation = windowLocation

      if (newLocation.indexOf('#') != -1) {
        newLocation = newLocation.substring(0, newLocation.indexOf('#'))
      }

      if ($(this).next('.program-type-inside, .course-type-inside').css('display') === 'none') {
        history.replaceState({ path: this.path }, '', newLocation + '#' + programTitle)
      } else {
        history.replaceState({ path: this.path }, '', newLocation)
      }
    })
  }
})();

/*
 * manage expandable lists state
 */
(function () {
  var expandableButtons = document.querySelectorAll('.js-expandable-button')

  if (expandableButtons.lenth <= 0) {
    return
  }

  for (var i = 0; i < expandableButtons.length; i++) {
    expandableButtons[i].addEventListener('click', function (event) {
      var trigger = event.currentTarget
      var targetId = trigger.getAttribute('aria-controls')
      var targetEl = document.getElementById(targetId)
      var parent = trigger.parentNode

      if (targetEl == null || typeof targetEl === 'undefined') {
        return
      }

      if (targetEl.classList.contains('expanded')) {
        trigger.classList.remove('active')
        trigger.setAttribute('aria-expanded', 'false')
        $(targetEl).slideUp().removeClass('expanded')

        if (parent.classList.contains('expandable-list__subitem')) {
          parent.classList.remove('expanded')
        }
      } else {
        trigger.classList.add('active')
        trigger.setAttribute('aria-expanded', 'true')
        $(targetEl).slideDown().addClass('expanded')

        if (parent.classList.contains('expandable-list__subitem')) {
          parent.classList.add('expanded')
        }
      }
    })
  }
})();

/*
 * manage expandable lists close buttons
 */
(function () {
  var expandableCloseButtons = document.querySelectorAll('.js-close-expandable-list')

  if (expandableCloseButtons.length <= 0) {
    return
  }

  for (var i = 0; i < expandableCloseButtons.length; i++) {
    expandableCloseButtons[i].addEventListener('click', function (event) {
      var trigger = event.currentTarget
      var targetId = trigger.getAttribute('data-close')
      var targetEl = document.getElementById(targetId)
      var targetButton = document.querySelector('[aria-controls="' + targetId + '"]')

      if (targetEl == null || typeof targetEl === 'undefined' ||
        targetButton == null || typeof targetButton === 'undefined') {
        return
      }

      targetButton.classList.remove('active')
      targetButton.setAttribute('aria-expanded', 'false')
      $(targetEl).slideUp().removeClass('expanded')
    })
  }
})()
